export default __webpack_public_path__ + "1f2b6a3b9ca04be5a37cc6f046c2048e.svg";